<template>
    <div class="modal fade" id="budgetInfoModal" tabindex="-1" role="dialog" aria-labelledby="budgetInfoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <form class="modal-content" @submit.prevent="store">
                <div class="modal-header">
                    <h5 class="modal-title" id="budgetInfoModalLabel">Редактирование бюджета</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('name')}" v-model="form.name" placeholder="Название">

                                <span class="invalid-feedback">{{ getError('name') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <multiselect v-model="form.accounts" :multiple="true" :options="accounts" :placeholder="$t('Счета')" :custom-label="nameWithBalance" label="title" track-by="id"></multiselect>

                                <span class="invalid-feedback">{{ getError('accounts') }}</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="alert alert-warning">Если вы уберет счета которые были использованы при рассчетах фактических трат, все траты для этого бюджета буду пересчитаны, и удаленные счета не будут больше учтены.</div>
                        </div>
                        <div class="col-12" v-if="! budget.is_main">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="form.is_main" id="isMainCheckbox">
                                <label class="form-check-label" for="isMainCheckbox">
                                    <span>Сделать бюджет основным</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" @click.prevent="deleteBudget" class="btn btn-danger mr-auto"><i class="fas fa-trash"></i> Удалить</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">{{ $t('Закрыть') }}</button>
                    <button type="submit" class="btn btn-success">{{ $t('Сохранить') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
    props: ['budget'],

    data: function() {
        return {
            form: this.budget,

            loaded: false,

            errors: {},
        };
    },
    
    mounted() {
        //
    },

    computed: {
        ...mapGetters(['accounts']),
    },

    watch: {
        budget: function() {
            this.form = Object.assign({}, this.budget);
            this.form.accounts = this.budget.accounts.map((id) => {
                return this.accounts.find((account) => account.id === id);
            }).filter(account => account !== null || account !== undefined);
        },
    },

    methods: {
        ...mapActions(['loadAccounts']),

        nameWithBalance({ title, amount, currency }) {
            let balance = this.$options.filters.money(amount);

            return `${title} — ${balance} ${currency}`;
        },

        store() {
            axios.post(`/budget/${this.form.id}`, this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message ? data.message : $t('Бюджет сохранен'), 'success');

                    this.$emit('saved');

                    $("#budgetInfoModal").modal('hide');
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        deleteBudget() {
            this.$ga.event('budgetDelete', 'clicked');

            if(! confirm('Вы точно желеаете удалить бюджет? Все запланированные данные нельзя будет восстановить.')) {
                return;
            }

            axios.delete(`/budget/${this.form.id}`)
                .then(({data}) => {
                    $("#budgetInfoModal").modal('hide');

                    EventBus.$emit('show-alert', data.message ? data.message : $t('Бюджет удален'), 'success');

                    this.$ga.event('budgetDelete', 'deleted');

                    this.$router.push(`/budget`);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
}
</script>

<style lang="scss">
//
</style>